module.exports = __webpack_public_path__ + "static/img/solutions-8.cdbc2dc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/solutions-8.jpeg
// module id = TR0q
// module chunks = 1